<template>
  <div class="poster-container" :style="{ backgroundImage: `url(${backgroundUrl||posterBgImage})` }">
    <SitePoster v-if="posterType === POSTER_TYPE.SITE" :ref="POSTER_TYPE.SITE" @initialized="initPoster(POSTER_TYPE.SITE)" />
    <AchievementPoster
      v-else-if="posterType === POSTER_TYPE.ACHIEVEMENT"
      :ref="POSTER_TYPE.ACHIEVEMENT"
      :type="achievementPosterType"
      @initialized="initPoster(POSTER_TYPE.ACHIEVEMENT)"
    />
    <div class="poster-share">
      <div class="poster-img-container">
        <img class="poster-img" :src="posterUrl" :style="{ visibility: !!posterUrl ? '' : 'hidden' }" />
      </div>
      <PosterShareButton :type="posterShareBtnType" :scene="scene" @onBack="handleBack" @onGeneratePoster="handleGeneratePoster" />
    </div>
  </div>
</template>

<script>
import { POSTER_TYPE } from '../../dictionary'
import PosterShareButton from './components/PosterShareButton'
import html2canvas from 'html2canvas'
import { mapMutations, mapGetters } from 'vuex'

const AchievementPoster = () => import('./components/AchievementPoster')

const SitePoster = () => import('./components/SitePoster')

export default {
  name: 'Poster',
  components: { SitePoster, PosterShareButton, AchievementPoster },
  props: {
    posterType: String
  },
  data() {
    return {
      posterUrl: '',
      achievementPosterType: '',
      preAchievementPosterUrl: '',
      achievementPosterUrl: '',
      posterBgImage: require('../../assets/images/bg2.png')
    }
  },
  computed: {
    ...mapGetters({
      activityId: 'activityInfo/activityId',
      activityInfo: 'activityInfo/activityInfo'
    }),
    POSTER_TYPE() {
      return POSTER_TYPE
    },
    posterShareBtnType() {
      return this.posterType === POSTER_TYPE.SITE || this.achievementPosterType === 'poster' ? 'back' : ''
    },
    scene() {
      return this.$route.query?.rid ? 'share' : ''
    },
    backgroundUrl() {
      return this.activityInfo.mapStyle.material ? this.activityInfo.mapStyle.material.backgroundUrl : ''
    }
  },
  async created() {
    this.init()
  },
  methods: {
    ...mapMutations({
      showLoading: 'loading/showLoading',
      hideLoading: 'loading/hideLoading',
      showToast: 'toast/showToast'
    }),
    init() {
      this.posterType === POSTER_TYPE.SITE && this.showLoading('海报生成中...')
    },
    initPoster(ref = POSTER_TYPE.ACHIEVEMENT) {
      this.showLoading('海报生成中...')
      if (ref === POSTER_TYPE.ACHIEVEMENT) {
        if (this.achievementPosterType === '' && !!this.preAchievementPosterUrl) {
          this.posterUrl = this.preAchievementPosterUrl
          this.hideLoading()
          return
        }
        if (this.achievementPosterType === 'poster' && !!this.achievementPosterUrl) {
          this.posterUrl = this.achievementPosterUrl
          this.hideLoading()
          return
        }
      }

      this.html2canvas(this.$refs[ref].$el).then(res => {
        this.posterUrl = res
        if (ref === POSTER_TYPE.ACHIEVEMENT) {
          if (this.achievementPosterType === '') {
            this.preAchievementPosterUrl = res
          } else {
            this.achievementPosterUrl = res
          }
        }
        this.hideLoading()
        this.posterType === POSTER_TYPE.SITE && this.showToast('打卡成功')
      })
    },
    html2canvas(dom) {
      return new Promise(resolve => {
        html2canvas(dom, {
          x: -9999,
          y: -9999,
          scrollX: 0,
          scrollY: 0,
          // dpi: window.devicePixelRatio * 1,
          width: dom.offsetWidth,
          height: dom.offsetHeight,
          backgroundColor: 'transparent',
          useCORS: true,
          scale: window.devicePixelRatio,
          windowWidth: document.body.scrollWidth,
          windowHeight: document.body.scrollHeight
        }).then(canvas => {
          resolve(canvas.toDataURL('image/png'))
        })
      })
    },
    handleBack() {
      this.posterUrl = ''
      this.posterType === POSTER_TYPE.ACHIEVEMENT ? (this.achievementPosterType = '') : this.$router.back()
    },
    handleGeneratePoster() {
      if (this.scene === 'share') {
        this.$router.push({
          path: '/',
          query: { id: this.$store.getters['activityInfo/activityId'] }
        })
        return
      }
      this.showLoading('海报生成中...')
      this.posterUrl = ''
      this.achievementPosterType = 'poster'
    },
    handleDetail() {
      if (!this.activityId) return
    }
  }
}
</script>

<style lang="scss" scoped>
.poster-container {
  height: 100vh;
  width: 100vw;
  // background-image: url("../../assets/images/bg2.png");
  background-repeat: no-repeat;
  background-size: 100vw 100vh;
  overflow: hidden;

  .poster-share {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding-top: 0.31rem;

    .poster-img-container {
      width: 6.8rem;
      min-height: 7.3rem;
      max-height: 11.6rem;
      overflow-x: hidden;
      overflow-y: auto;
      border-radius: 0.2rem;
      margin: 0 auto;

      .poster-img {
        width: 6.8rem;
        min-height: 7.3rem;
        vertical-align: bottom;
      }
    }
  }
}
</style>
